module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_c('div', {
    staticClass: "icon-warp"
  }, [_c('div', {
    staticClass: "plus-warp",
    on: {
      "touchstart": function($event) {
        _vm.click(_vm.plusValue)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-xiao64-copy",
    attrs: {
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "sub-warp",
    on: {
      "touchstart": function($event) {
        _vm.click(_vm.subValue)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-jian",
    attrs: {
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-826b4a24"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/items/volumeButton.vue
// module id = 914
// module chunks = 1